import config from '@/assets/config';

export const AuthService = {

  async getEntraIdSettings() {
    var response = await fetch(config.backendUrl + config.authConfigRoute);
    const data = await response.json();
    return data;
  },

  async getConfiguration(){
    
    var entraIdSettings = await this.getEntraIdSettings();
    if (!entraIdSettings) {
      console.error('Entra ID settings not found');
      return null;
    }

    return {
      auth: {
        clientId: entraIdSettings.clientId,
        authority: entraIdSettings.instance + entraIdSettings.tenantId,
        redirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: config.entraIdCacheLocation, 
        storeAuthStateInCookie: config.entraIdStoreAuthStateInCookie, 
      },
    }
  },

  async loginRequest() {
    var entraIdSettings = await this.getEntraIdSettings();
    return { scopes: [ "openid", "profile", "email", `api://${entraIdSettings.clientId}/user.read` ] };
  },

  async getToken(instance, account) {
    var entraIdSettings = await this.getEntraIdSettings();
    return await instance.acquireTokenSilent({
      scopes: [`api://${entraIdSettings.clientId}/user.read`],
      account: account,
    });
  }
}